import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const STR = {
  en: {
    "brand.eyebrow": "DIYLegal.info",
    "brand.title": "DIY Legal Info",
    "brand.tagline": "UNDERSTAND IT. ORGANIZE IT. NAVIGATE IT.",
    "nav.home": "Home",
    "nav.learn": "Learn",
    "nav.my_case": "My Case",
    "nav.practice": "Practice",
    "nav.resources": "Resources",
    "nav.deborah": "Assistant",
    "auth.sign_in": "Sign in",
    "auth.sign_out": "Sign out",
    "auth.create_account": "Create account",
    "auth.loading": "Loading...",
    "lang.toggle": "Español",
    "lang.current": "English",
    "home.hero_pill": "You Got Served. Now What?",
    "home.hero_title_1": "GOT COURT PAPERS?",
    "home.hero_title_2": "DON'T PANIC.",
    "home.hero_title_3": "GET COURT READY.",
    "home.hero_sub": "DIY Legal helps self-represented people understand court documents, organize deadlines, find legal information, prepare for court, and navigate the court system — with technology and human support when you need it.",
    "home.cta_start": "I Got Served. Now What?",
    "home.cta_ask_deborah": "Meet a Community Court Navigator",
    "home.section_title": "What do you need help with today?",
    "home.section_sub": "Pick any card. You can change your mind anytime.",
    "home.tagline_kicker": "DIY Legal",
    "home.tagline_full": "Know Where You Are. Know What's Next. Be Court Ready.",
    "home.tagline_sub": "Legal Literacy. Court Navigation. Human Support.",
    "home.whn_kicker": "You Are Here",
    "home.whn_title": "What Happens Next?",
    "home.whn_sub": "Follow the six steps every self-represented litigant walks through — from paperwork to hearing.",
    "home.whn_step1": "You Are Here",
    "home.whn_step1_d": "Point to your place in the process.",
    "home.whn_step2": "This Happened",
    "home.whn_step2_d": "Understand what just landed on your doorstep.",
    "home.whn_step3": "Your Next Step",
    "home.whn_step3_d": "One clear action, not a legal lecture.",
    "home.whn_step4": "Your Next Important Date",
    "home.whn_step4_d": "The deadline you cannot miss.",
    "home.whn_step5": "What to Prepare",
    "home.whn_step5_d": "Documents, questions, and evidence to have ready.",
    "home.whn_step6": "Be Court Ready",
    "home.whn_step6_d": "Walk in organized, respectful, and calm.",
    "home.whn_cta": "Start with my case",
    "home.open": "Open",
    "home.legal_notice": "DIYLegal.info provides general legal-literacy, educational, organizational, and resource-navigation information. It does not provide legal advice or representation.",
    "deborah.title": "DIY Legal Assistant",
    "deborah.subtitle": "General educational information about how the legal system works — not legal advice.",
    "deborah.placeholder": "Ask a general question about court, papers, or a legal term...",
    "deborah.suggest_prompt": "Ask a general question about court, papers, or a legal term.",
    "deborah.send": "Send",
    "deborah.thinking": "Thinking...",
    "deborah.mic_label": "Speak your question",
    "deborah.speak_answer": "Play answer",
    "deborah.stop_answer": "Stop",
    "learn.title": "Learning Academy",
    "learn.subtitle": "Short lessons with quick activities. Answer a quiz and try a teach-back to finish each one.",
    "learn.progress": "Your progress",
    "learn.progress_of": "of",
    "learn.progress_complete": "lessons complete",
    "learn.loading": "Loading lessons...",
    "learn.synced": "Synced to your account",
    "learn.academy_complete": "Academy complete",
    "learn.section_read": "Read",
    "learn.section_quiz": "Quick quiz",
    "learn.section_teach": "Teach it back",
    "learn.section_scenario": "Scenario to think about",
    "learn.teach_placeholder": "Type your answer in your own words...",
    "learn.mark_complete": "Mark lesson complete",
    "learn.mark_incomplete": "Mark as not complete",
    "learn.quiz_gate": "Answer at least half the quiz correctly to mark this lesson complete.",
    "learn.lesson_complete": "Lesson complete",
    "learn.open": "Open",
    "learn.hide": "Hide",
    "learn.why": "Why:",
    "glossary.title": "Legal terms in plain English",
    "glossary.subtitle": "Search common court and legal words. Tap a term to learn more.",
    "glossary.placeholder": "Try 'summons', 'default', or 'garnishment'...",
    "glossary.no_match": "No terms match",
    "glossary.field.example": "Example",
    "glossary.field.where": "Where you'll see it",
    "glossary.field.why": "Why it matters",
    "roles.title": "Who does what in a courtroom?",
    "roles.subtitle": "The people around you have specific jobs. Here's a plain-English guide.",
    "roles.tip": "Tip:",
    "paths.title": "P.A.T.H.S. — a way to think about any situation",
    "paths.subtitle": "Five short questions to move from confusion to a next step.",
    "whatif.title": "What if this happens?",
    "whatif.subtitle": "Common situations self-represented people run into, with next steps.",
    "whatif.open": "Open",
    "whatif.hide": "Hide",
    "whatif.what": "What it means",
    "whatif.check": "Check for",
    "whatif.who": "Who can help",
    "resources.title": "Resources near you",
    "resources.subtitle": "Verified legal-aid organizations, court clerks, and self-help centers.",
    "resources.filter_state": "State",
    "resources.filter_county": "County (all)",
    "resources.filter_category": "Category (all)",
    "resources.visit_site": "Visit website",
    "resources.verified": "Verified",
    "practice.title": "Practice talking in court",
    "practice.subtitle": "Rehearse respectful, clear phrases. Get quick coaching on clarity, tone, and answering the question.",
    "practice.scenario": "Scenario",
    "practice.your_response": "Your response",
    "practice.get_feedback": "Get feedback",
    "practice.feedback_clarity": "Clarity",
    "practice.feedback_tone": "Tone",
    "practice.feedback_answering": "Answering the question",
    "practice.overall": "Overall",
    "practice.tip": "Tip",
    "caselaw.title": "Case-law lookup",
    "caselaw.subtitle": "Search plain-English overviews and links to free case-law databases. Not legal advice.",
    "caselaw.placeholder": "Search cases, doctrines, or citations...",
    "caselaw.search": "Search",
    "caselaw.saved": "Saved searches",
    "caselaw.save": "Save this search",
    "caselaw.remove": "Remove",
    "caselaw.overview": "Overview",
    "caselaw.links": "Verified free sources",
    "caselaw.needs_verification": "Needs verification",
    "mycase.title": "My case prep",
    "mycase.subtitle": "Build your personal checklist and timeline. Everything saves to your device (and to your account when signed in).",
    "mycase.checklist": "Preparation checklist",
    "mycase.shortcuts_title": "Free AI tools for your case",
    "mycase.shortcut_summarize_title": "Explain a court document",
    "mycase.shortcut_summarize_desc": "Upload or paste a filing and get a plain-English summary.",
    "mycase.shortcut_practice_title": "Practice with AI feedback",
    "mycase.shortcut_practice_desc": "Rehearse your hearing and get instant, judge-tone feedback.",
    "mycase.shortcut_open": "Open",
    "mycase.shortcut_free_left": "free uses left",
    "mycase.shortcut_unlimited": "Unlimited (Premium)",
    "mycase.countdown_today": "Your next important date is today",
    "mycase.countdown_tomorrow": "Just 1 day left",
    "mycase.countdown_days_prefix": "T-minus",
    "mycase.countdown_days_suffix": "days",
    "mycase.countdown_past_prefix": "",
    "mycase.countdown_past_suffix": "days ago",
    "mycase.timeline": "My timeline",
    "mycase.add_event": "Add event",
    "mycase.event_name": "Event name",
    "mycase.event_date": "Date",
    "mycase.event_notes": "Notes (optional)",
    "mycase.clear": "Clear all",
    "mycase.no_events": "No events yet. Add your first court date or deadline.",
    "mycase.7d": "7 days before",
    "mycase.24h": "24 hours before",
    "mycase.court_day": "Court day",
    "mycase.after_court": "After court",
    "mycase.reminders_title": "SMS reminders",
    "mycase.reminders_desc": "We'll text you 24 hours and 1 hour before every date on your timeline.",
    "mycase.reminders_phone": "Phone (E.164 format, e.g. +15551234567)",
    "mycase.reminders_lang": "SMS language",
    "mycase.reminders_save": "Save",
    "mycase.reminders_test": "Send test SMS",
    "mycase.reminders_saved": "Saved",
    "mycase.reminders_sent": "Test SMS sent",
    "mycase.reminders_disabled": "No number saved — reminders are off.",
    "mycase.reminders_consent": "I agree to receive SMS reminders from DIYLegal.info at this number. Message and data rates may apply. Reply STOP to unsubscribe.",
    "mycase.reminders_consent_required": "Please check the consent box before saving.",
    "mycase.verify_send": "Send code",
    "mycase.verify_sent": "Code sent — check your phone",
    "mycase.verify_code": "6-digit code",
    "mycase.verify_check": "Verify code",
    "mycase.verify_success": "Phone verified",
    "mycase.verify_error": "Code was not correct",
    "mycase.verify_pending": "Verify your phone before saving. Enter the 6-digit code we sent to",
    "mycase.verify_verified": "Phone verified",
    "mycase.verify_needed": "This phone number is not verified yet.",
    "intake.progress_of": "of",
    "intake.progress_question": "Question",
    "intake.back": "Back",
    "intake.next": "Next",
    "intake.submit": "Show me my starting map",
    "intake.take_time": "Take your time. You can skip a question if you're not sure.",
    "intake.mic_label": "Answer by voice",
    "intake.result_title": "Here's a starting map",
    "intake.plain_summary": "Plain-English summary",
    "intake.steps_title": "Next steps you can take",
    "intake.resources_title": "Places to check for help",
    "intake.questions_title": "Questions you may want to ask",
    "intake.goto_deborah": "Ask the assistant about this",
    "intake.goto_mycase": "Build my case prep",
    "summarize.title": "Explain this document",
    "summarize.subtitle": "Paste any court paper, notice, or letter. We'll break it down in plain English.",
    "summarize.placeholder": "Paste the text of your document here...",
    "summarize.upload_title": "Or upload a document",
    "summarize.upload_hint": "PDF is auto-summarized. JPG/PNG/WEBP up to 10 MB.",
    "summarize.choose_file": "Choose file",
    "summarize.submit": "Break it down for me",
    "summarize.one_sentence": "One-sentence summary",
    "summarize.plain": "Plain-English summary",
    "summarize.who": "Who is involved",
    "summarize.what": "What it says",
    "summarize.dates": "Important dates",
    "summarize.amounts": "Important amounts",
    "summarize.terms": "Legal terms to know",
    "summarize.verify": "Things to verify",
    "summarize.attorney_questions": "Questions to ask an attorney",
    "waiver.title": "Fee Waiver Draft Builder",
    "waiver.subtitle": "Fill this in to draft an Application for Waiver of Court Fees. Print or save when done. Then attach or copy the information onto the official form your court requires.",
    "waiver.disclaimer": "This is a personal draft to help you organize. It is not a filed application. Your county's court may require a specific approved form — always confirm with the clerk.",
    "waiver.storage_signed_in": "Your draft is saved to your account and to this device. Use \"Clear draft\" when you're done.",
    "waiver.storage_anonymous": "Your draft is stored only in this browser. Sign in to also save it to your account.",
    "waiver.print": "Print / Save as PDF",
    "waiver.reset": "Start over",
    "waiver.clear": "Clear draft",
    "waiver.section_case": "Application for Waiver of Court Fees — Draft",
    "waiver.section_household": "Household & income",
    "waiver.section_benefits": "Do you receive any of these public benefits?",
    "waiver.section_expenses": "Monthly expenses ($)",
    "waiver.section_reason": "Why you cannot afford court fees",
    "waiver.reason_placeholder": "Explain in a few sentences why paying the filing fee would be a hardship.",
    "waiver.total_exp": "Total monthly expenses (draft):",
    "waiver.email": "Email me my draft",
    "waiver.email_sent": "Draft emailed to",
    "waiver.email_signin": "Sign in to email yourself a copy",
    "auth.welcome_back": "Welcome back",
    "auth.sign_in_desc": "Sign in to save your checklist, timeline, and chat.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.or": "OR",
    "auth.new_here": "New here?",
    "auth.create_your_account": "Create your account",
    "auth.create_desc": "Free. Optional. You can also keep using the app anonymously.",
    "auth.your_name": "Your name (optional)",
    "auth.password_min": "Password (min 8 characters)",
    "auth.already_have": "Already have an account?",
    "auth.privacy_note": "We only use your email to sign you in and save your case data. Do not share Social Security numbers, bank credentials, or unnecessary sensitive information.",
    "auth.google_signup": "Sign up with Google",
    "auth.google_error": "We couldn't complete Google sign-in. Please try again or use your email and password.",
    "auth.password_short": "Password must be at least 8 characters.",
    "home.framework": "Framework",
    "home.paths_short": "P.A.T.H.S. Navigation",
    "home.paths_desc": "Purpose · Access · Trustworthy · Handoff · Steps",
    "home.who_is_who": "Who is who?",
    "home.roles_short": "Courtroom roles",
    "home.roles_desc": "Judge · Clerk · Bailiff · Attorneys · You",
    "home.decision_center": "Decision center",
    "home.whatif_short": "\"What if...\" questions",
    "home.whatif_desc": "Common situations and next steps",
  },
  es: {
    "brand.eyebrow": "DIYLegal.info",
    "brand.title": "DIY Legal Info",
    "brand.tagline": "ENTIÉNDELO. ORGANÍZALO. NAVÉGALO.",
    "nav.home": "Inicio",
    "nav.learn": "Aprender",
    "nav.my_case": "Mi caso",
    "nav.practice": "Practicar",
    "nav.resources": "Recursos",
    "nav.deborah": "Asistente",
    "auth.sign_in": "Iniciar sesión",
    "auth.sign_out": "Cerrar sesión",
    "auth.create_account": "Crear cuenta",
    "auth.loading": "Cargando...",
    "lang.toggle": "English",
    "lang.current": "Español",
    "home.hero_pill": "Me demandaron. ¿Y ahora qué?",
    "home.hero_title_1": "¿RECIBISTE PAPELES DE LA CORTE?",
    "home.hero_title_2": "NO ENTRES EN PÁNICO.",
    "home.hero_title_3": "PREPÁRATE PARA LA CORTE.",
    "home.hero_sub": "DIY Legal ayuda a las personas auto-representadas a entender documentos de la corte, organizar plazos, encontrar información legal, prepararse para la corte y navegar el sistema — con tecnología y apoyo humano cuando lo necesites.",
    "home.cta_start": "Me demandaron. ¿Y ahora qué?",
    "home.cta_ask_deborah": "Conoce a una Navegadora Comunitaria",
    "home.section_title": "¿Con qué necesitas ayuda hoy?",
    "home.section_sub": "Elige cualquier tarjeta. Puedes cambiar de opinión cuando quieras.",
    "home.tagline_kicker": "DIY Legal",
    "home.tagline_full": "Sabe dónde estás. Sabe qué sigue. Prepárate para la corte.",
    "home.tagline_sub": "Alfabetización legal. Navegación de corte. Apoyo humano.",
    "home.whn_kicker": "Estás aquí",
    "home.whn_title": "¿Qué pasa después?",
    "home.whn_sub": "Sigue los seis pasos que recorre cada persona auto-representada — de los papeles a la audiencia.",
    "home.whn_step1": "Estás aquí",
    "home.whn_step1_d": "Ubica dónde te encuentras en el proceso.",
    "home.whn_step2": "Esto pasó",
    "home.whn_step2_d": "Entiende qué acaba de llegar a tu puerta.",
    "home.whn_step3": "Tu próximo paso",
    "home.whn_step3_d": "Una acción clara, no una lección legal.",
    "home.whn_step4": "Tu próxima fecha importante",
    "home.whn_step4_d": "La fecha límite que no puedes perder.",
    "home.whn_step5": "Qué preparar",
    "home.whn_step5_d": "Documentos, preguntas y evidencia listos.",
    "home.whn_step6": "Preparada para la corte",
    "home.whn_step6_d": "Entra organizada, respetuosa y con calma.",
    "home.whn_cta": "Empezar con mi caso",
    "home.open": "Abrir",
    "home.legal_notice": "DIYLegal.info ofrece información educativa y de navegación de recursos. No brinda asesoría legal ni representación.",
    "deborah.title": "Asistente DIY Legal",
    "deborah.subtitle": "Información educativa general sobre cómo funciona el sistema legal — no es asesoría legal.",
    "deborah.placeholder": "Haz una pregunta general sobre la corte, papeles o un término legal...",
    "deborah.suggest_prompt": "Haz una pregunta general sobre la corte, papeles o un término legal.",
    "deborah.send": "Enviar",
    "deborah.thinking": "Pensando...",
    "deborah.mic_label": "Habla tu pregunta",
    "deborah.speak_answer": "Reproducir respuesta",
    "deborah.stop_answer": "Detener",
    "learn.title": "Academia de Aprendizaje",
    "learn.subtitle": "Lecciones cortas con actividades rápidas. Responde una prueba y haz un 'enséñalo de vuelta' para terminar cada una.",
    "learn.progress": "Tu progreso",
    "learn.progress_of": "de",
    "learn.progress_complete": "lecciones completadas",
    "learn.loading": "Cargando lecciones...",
    "learn.synced": "Sincronizado con tu cuenta",
    "learn.academy_complete": "Academia completa",
    "learn.section_read": "Lee",
    "learn.section_quiz": "Prueba rápida",
    "learn.section_teach": "Enséñalo de vuelta",
    "learn.section_scenario": "Escenario para pensar",
    "learn.teach_placeholder": "Escribe tu respuesta con tus propias palabras...",
    "learn.mark_complete": "Marcar lección como completa",
    "learn.mark_incomplete": "Marcar como no completa",
    "learn.quiz_gate": "Responde correctamente al menos la mitad de la prueba para marcar la lección como completa.",
    "learn.lesson_complete": "Lección completa",
    "learn.open": "Abrir",
    "learn.hide": "Ocultar",
    "learn.why": "Por qué:",
    "glossary.title": "Términos legales en palabras sencillas",
    "glossary.subtitle": "Busca palabras comunes de la corte. Toca un término para saber más.",
    "glossary.placeholder": "Prueba con 'citación', 'rebeldía' o 'embargo'...",
    "glossary.no_match": "Ningún término coincide con",
    "glossary.field.example": "Ejemplo",
    "glossary.field.where": "Dónde lo verás",
    "glossary.field.why": "Por qué importa",
    "roles.title": "¿Quién hace qué en la sala de la corte?",
    "roles.subtitle": "Las personas a tu alrededor tienen trabajos específicos. Aquí tienes una guía en lenguaje sencillo.",
    "roles.tip": "Consejo:",
    "paths.title": "P.A.T.H.S. — una forma de pensar cualquier situación",
    "paths.subtitle": "Cinco preguntas cortas para pasar de la confusión al siguiente paso.",
    "whatif.title": "¿Y si pasa esto?",
    "whatif.subtitle": "Situaciones comunes que enfrentan las personas auto-representadas, con próximos pasos.",
    "whatif.open": "Abrir",
    "whatif.hide": "Ocultar",
    "whatif.what": "Qué significa",
    "whatif.check": "Qué revisar",
    "whatif.who": "Quién puede ayudar",
    "resources.title": "Recursos cerca de ti",
    "resources.subtitle": "Organizaciones de ayuda legal verificadas, secretarios/clerks y centros de autoayuda.",
    "resources.filter_state": "Estado",
    "resources.filter_county": "Condado (todos)",
    "resources.filter_category": "Categoría (todas)",
    "resources.visit_site": "Visitar sitio web",
    "resources.verified": "Verificado",
    "practice.title": "Practica hablar en la corte",
    "practice.subtitle": "Ensaya frases respetuosas y claras. Recibe retroalimentación rápida sobre claridad, tono y responder la pregunta.",
    "practice.scenario": "Escenario",
    "practice.your_response": "Tu respuesta",
    "practice.get_feedback": "Recibir retroalimentación",
    "practice.feedback_clarity": "Claridad",
    "practice.feedback_tone": "Tono",
    "practice.feedback_answering": "Responder la pregunta",
    "practice.overall": "En general",
    "practice.tip": "Consejo",
    "caselaw.title": "Búsqueda de jurisprudencia",
    "caselaw.subtitle": "Busca resúmenes en lenguaje sencillo y enlaces a bases de datos gratuitas. No es consejo legal.",
    "caselaw.placeholder": "Busca casos, doctrinas o citas...",
    "caselaw.search": "Buscar",
    "caselaw.saved": "Búsquedas guardadas",
    "caselaw.save": "Guardar esta búsqueda",
    "caselaw.remove": "Eliminar",
    "caselaw.overview": "Resumen",
    "caselaw.links": "Fuentes gratuitas verificadas",
    "caselaw.needs_verification": "Requiere verificación",
    "mycase.title": "Preparación de mi caso",
    "mycase.subtitle": "Arma tu lista personal y línea de tiempo. Todo se guarda en tu dispositivo (y en tu cuenta cuando inicias sesión).",
    "mycase.checklist": "Lista de preparación",
    "mycase.shortcuts_title": "Herramientas de IA gratis para tu caso",
    "mycase.shortcut_summarize_title": "Explica un documento de la corte",
    "mycase.shortcut_summarize_desc": "Sube o pega un escrito y recibe un resumen en lenguaje sencillo.",
    "mycase.shortcut_practice_title": "Practica con retroalimentación de IA",
    "mycase.shortcut_practice_desc": "Ensaya tu audiencia y recibe retroalimentación con tono de juez al instante.",
    "mycase.shortcut_open": "Abrir",
    "mycase.shortcut_free_left": "usos gratis restantes",
    "mycase.shortcut_unlimited": "Ilimitado (Premium)",
    "mycase.countdown_today": "Tu próxima fecha importante es hoy",
    "mycase.countdown_tomorrow": "Solo queda 1 día",
    "mycase.countdown_days_prefix": "Faltan",
    "mycase.countdown_days_suffix": "días",
    "mycase.countdown_past_prefix": "Hace",
    "mycase.countdown_past_suffix": "días",
    "mycase.timeline": "Mi línea de tiempo",
    "mycase.add_event": "Añadir evento",
    "mycase.event_name": "Nombre del evento",
    "mycase.event_date": "Fecha",
    "mycase.event_notes": "Notas (opcional)",
    "mycase.clear": "Borrar todo",
    "mycase.no_events": "Aún no hay eventos. Añade tu primera fecha o plazo.",
    "mycase.7d": "7 días antes",
    "mycase.24h": "24 horas antes",
    "mycase.court_day": "Día de corte",
    "mycase.after_court": "Después de la corte",
    "mycase.reminders_title": "Recordatorios por SMS",
    "mycase.reminders_desc": "Recibirás un SMS 24 horas y 1 hora antes de cada fecha en tu línea de tiempo.",
    "mycase.reminders_phone": "Teléfono (formato E.164, ej. +15551234567)",
    "mycase.reminders_lang": "Idioma del SMS",
    "mycase.reminders_save": "Guardar",
    "mycase.reminders_test": "Enviar SMS de prueba",
    "mycase.reminders_saved": "Guardado",
    "mycase.reminders_sent": "SMS de prueba enviado",
    "mycase.reminders_disabled": "Sin número guardado — los recordatorios están desactivados.",
    "mycase.reminders_consent": "Acepto recibir SMS de recordatorio de DIYLegal.info a este número. Pueden aplicar tarifas de mensaje y datos. Responde STOP para cancelar.",
    "mycase.reminders_consent_required": "Marca la casilla de consentimiento antes de guardar.",
    "mycase.verify_send": "Enviar código",
    "mycase.verify_sent": "Código enviado — revisa tu teléfono",
    "mycase.verify_code": "Código de 6 dígitos",
    "mycase.verify_check": "Verificar código",
    "mycase.verify_success": "Teléfono verificado",
    "mycase.verify_error": "El código no era correcto",
    "mycase.verify_pending": "Verifica tu teléfono antes de guardar. Ingresa el código de 6 dígitos que enviamos a",
    "mycase.verify_verified": "Teléfono verificado",
    "mycase.verify_needed": "Este número aún no está verificado.",
    "intake.progress_of": "de",
    "intake.progress_question": "Pregunta",
    "intake.back": "Atrás",
    "intake.next": "Siguiente",
    "intake.submit": "Muéstrame mi mapa inicial",
    "intake.take_time": "Tómate tu tiempo. Puedes saltar una pregunta si no estás seguro.",
    "intake.mic_label": "Responder por voz",
    "intake.result_title": "Aquí está tu mapa inicial",
    "intake.plain_summary": "Resumen en palabras sencillas",
    "intake.steps_title": "Próximos pasos que puedes tomar",
    "intake.resources_title": "Lugares donde buscar ayuda",
    "intake.questions_title": "Preguntas que quizás quieras hacer",
    "intake.goto_deborah": "Preguntarle al asistente sobre esto",
    "intake.goto_mycase": "Preparar mi caso",
    "summarize.title": "Explica este documento",
    "summarize.subtitle": "Pega cualquier papel, aviso o carta de la corte. Lo desglosaremos en palabras sencillas.",
    "summarize.placeholder": "Pega aquí el texto de tu documento...",
    "summarize.upload_title": "O sube un documento",
    "summarize.upload_hint": "El PDF se resume automáticamente. JPG/PNG/WEBP hasta 10 MB.",
    "summarize.choose_file": "Elegir archivo",
    "summarize.submit": "Desglósalo para mí",
    "summarize.one_sentence": "Resumen de una oración",
    "summarize.plain": "Resumen en palabras sencillas",
    "summarize.who": "Quiénes están involucrados",
    "summarize.what": "Qué dice",
    "summarize.dates": "Fechas importantes",
    "summarize.amounts": "Montos importantes",
    "summarize.terms": "Términos legales a conocer",
    "summarize.verify": "Cosas que verificar",
    "summarize.attorney_questions": "Preguntas para hacer a un abogado",
    "waiver.title": "Redactor de Exención de Tarifas",
    "waiver.subtitle": "Llena esto para redactar una Solicitud de Exención de Tarifas de la Corte. Imprime o guarda cuando termines. Luego adjunta o copia la información en el formulario oficial que pida tu corte.",
    "waiver.disclaimer": "Este es un borrador personal para ayudarte a organizarte. No es una solicitud presentada. Tu corte del condado puede requerir un formulario oficial — confirma siempre con el secretario/clerk.",
    "waiver.storage_signed_in": "Tu borrador se guarda en tu cuenta y en este dispositivo. Usa \"Borrar borrador\" cuando termines.",
    "waiver.storage_anonymous": "Tu borrador se guarda solo en este navegador. Inicia sesión para guardarlo también en tu cuenta.",
    "waiver.print": "Imprimir / Guardar como PDF",
    "waiver.reset": "Empezar de nuevo",
    "waiver.clear": "Borrar borrador",
    "waiver.section_case": "Solicitud de Exención de Tarifas — Borrador",
    "waiver.section_household": "Hogar e ingresos",
    "waiver.section_benefits": "¿Recibes alguno de estos beneficios públicos?",
    "waiver.section_expenses": "Gastos mensuales ($)",
    "waiver.section_reason": "Por qué no puedes pagar las tarifas",
    "waiver.reason_placeholder": "Explica en unas oraciones por qué pagar la tarifa sería una dificultad.",
    "waiver.total_exp": "Total de gastos mensuales (borrador):",
    "waiver.email": "Enviarme mi borrador por correo",
    "waiver.email_sent": "Borrador enviado a",
    "waiver.email_signin": "Inicia sesión para enviarte una copia",
    "auth.welcome_back": "Bienvenido de vuelta",
    "auth.sign_in_desc": "Inicia sesión para guardar tu lista, línea de tiempo y chat.",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.or": "O",
    "auth.new_here": "¿Nuevo aquí?",
    "auth.create_your_account": "Crea tu cuenta",
    "auth.create_desc": "Gratis. Opcional. También puedes seguir usando la app de forma anónima.",
    "auth.your_name": "Tu nombre (opcional)",
    "auth.password_min": "Contraseña (mínimo 8 caracteres)",
    "auth.already_have": "¿Ya tienes cuenta?",
    "auth.privacy_note": "Solo usamos tu correo para autenticarte y guardar los datos de tu caso. No compartas números de Seguro Social, credenciales bancarias ni información sensible innecesaria.",
    "auth.google_signup": "Registrarse con Google",
    "auth.google_error": "No pudimos completar el inicio de sesión con Google. Intenta de nuevo o usa tu correo y contraseña.",
    "auth.password_short": "La contraseña debe tener al menos 8 caracteres.",
    "home.framework": "Marco",
    "home.paths_short": "Navegación P.A.T.H.S.",
    "home.paths_desc": "Propósito · Acceso · Confiable · Handoff · Pasos",
    "home.who_is_who": "¿Quién es quién?",
    "home.roles_short": "Roles de la sala",
    "home.roles_desc": "Juez · Clerk · Bailiff · Abogados · Tú",
    "home.decision_center": "Centro de decisiones",
    "home.whatif_short": "Preguntas \"¿Y si...?\"",
    "home.whatif_desc": "Situaciones comunes y próximos pasos",
  },
};

const KEY = "pod_lang_v1";
const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(KEY) || "en");

  useEffect(() => { localStorage.setItem(KEY, lang); document.documentElement.lang = lang; }, [lang]);

  const setLang = useCallback((next) => setLangState(next === "es" ? "es" : "en"), []);
  const toggle = useCallback(() => setLangState((l) => (l === "en" ? "es" : "en")), []);

  const t = useCallback((key, fallback) => {
    return (STR[lang] && STR[lang][key]) || STR.en[key] || fallback || key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, setLang, toggle, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
